import React from 'react'
import { PriorityHigh, WarningAmber } from '@mui/icons-material'
import { VALIDATION_TYPES } from 'helpers/constants'
import { Box, Stack } from '@mui/material'
import { Trans } from 'react-i18next'
import { ValidationMessage } from 'types'

interface ValidationListProps {
  options: ValidationMessage[]
}

function ValidationList(props: ValidationListProps) {
  const { options } = props

  return (
    <Stack direction="column" spacing={1} sx={{ px: 1, py: 1 }}>
      {options.map((item) => (
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-start"
          alignItems="center"
          key={item.id}
        >
          <div>
            {VALIDATION_TYPES.VALIDATION_TYPE_WARN ? (
              <WarningAmber sx={{ color: 'primary.main' }} />
            ) : (
              <PriorityHigh sx={{ color: 'red' }} />
            )}
          </div>
          <Box>
            <Trans i18nKey={item.label} />
          </Box>
        </Stack>
      ))}
    </Stack>
  )
}

export default ValidationList
